import { useDateFilterFormat } from "@/components/date-filter/date-filter-presets.ts";
import {
  AppliedFiltersChip,
  AppliedFilterSummaryItem,
} from "@/components/filter/AppliedFiltersChip.tsx";
import { formatColumnFilterValue } from "@/pages/employees/index/employee-column-filter-summary.ts";
import { isColumnFilterEmpty } from "@/pages/employees/index/use-employee-column-filters.ts";
import {
  ApiEmployeeColumn,
  ApiEmployeeColumnFilter,
} from "@/types/employees/employee-column.types.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface EmployeeColumnFiltersChipProps {
  filters: ApiEmployeeColumnFilter[];
  columnByKey: Map<string, ApiEmployeeColumn>;
  onClear: () => void;
  onOpen: () => void;
}

/**
 * Сводка применённых фильтров. Названия колонок и опций берутся из каталога,
 * поэтому отдельных запросов за справочниками, как в старом чипе, не нужно.
 */
export function EmployeeColumnFiltersChip({
  filters,
  columnByKey,
  onClear,
  onOpen,
}: EmployeeColumnFiltersChipProps) {
  const { t } = useTranslation();
  const { formatRange } = useDateFilterFormat();

  const summary = useMemo<AppliedFilterSummaryItem[]>(() => {
    const items: AppliedFilterSummaryItem[] = [];

    for (const filter of filters) {
      const column = columnByKey.get(filter.field);
      if (!column || isColumnFilterEmpty(filter)) continue;

      const value = formatColumnFilterValue(filter, column, t, formatRange);

      if (value) items.push({ label: column.title, value });
    }

    return items;
  }, [filters, columnByKey, formatRange, t]);

  return (
    <AppliedFiltersChip
      count={summary.length}
      summary={summary}
      onClear={onClear}
      onClick={onOpen}
    />
  );
}
